import script from "./BasePagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./BasePagination.vue?vue&type=script&lang=ts&setup=true"

import "./BasePagination.vue?vue&type=style&index=0&id=92093658&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92093658"]])

export default __exports__